import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "label", "hasError", "labelClassName", "hint"];
import clsx from 'clsx';
import React, { forwardRef } from 'react';
var styles = {
  "hint": "pbui-wjr7W",
  "hint--no-error": "pbui-lt3uO",
  "hint--has-error": "pbui-88EqZ",
  "label": "pbui-4De3l",
  "container": "pbui-BqVmN",
  "textarea": "pbui-hvsjH",
  "textarea--no-error": "pbui-gVsR6",
  "textarea--has-error": "pbui-HE-TB",
  "nothing": "pbui-GF25q"
};
import { Hint } from './Hint';
import { Label } from './Label';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = /*#__PURE__*/forwardRef(function Textarea(props, ref) {
  var className = props.className,
    label = props.label,
    hasError = props.hasError,
    labelClassName = props.labelClassName,
    hint = props.hint,
    rest = _objectWithoutProperties(props, _excluded);
  var textareaClasses = clsx(styles.textarea, className, hasError ? styles['textarea--has-error'] : styles['textarea--no-error']);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [label && /*#__PURE__*/_jsx(Label, {
      htmlFor: rest.id,
      className: labelClassName,
      children: label
    }), /*#__PURE__*/_jsx("textarea", _extends({
      ref: ref,
      className: textareaClasses,
      autoComplete: "one-time-code"
    }, rest)), hint && /*#__PURE__*/_jsx(Hint, {
      hasError: hasError,
      children: hint
    })]
  });
});
export default TextArea;